import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const InstrumentMaster = () => {
  const [instruments, setInstruments] = useState([]);
  const [loading, setLoading] = useState(true);

  // New Instrument Form
  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [price, setPrice] = useState("");
  const [assetType, setAssetType] = useState("Equity");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchInstruments = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/instruments`);
      setInstruments(Array.isArray(res.data) ? res.data : (res.data?.Instruments?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching instruments", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstruments();
  }, []);

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/admin/instruments`, {
        name,
        symbol,
        price: Number(price),
        assetType,
      });
      setName("");
      setSymbol("");
      setPrice("");
      setIsModalOpen(false);
      fetchInstruments();
    } catch (err) {
      alert("Failed to add instrument");
    }
  };

  const handleToggleTradable = async (id, currentStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/api/admin/instruments/${id}`, {
        isTradable: !currentStatus,
      });
      fetchInstruments();
    } catch (err) {
      alert("Failed to update status");
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#fff" }}>Stock Instrument Master Management</h2>
          <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
            Add/edit tradable stock symbols, configure LTP pricing feeds, and toggle trading availability
          </p>
        </div>

        <button onClick={() => setIsModalOpen(true)} style={btnStyle}>
          + Add Tradable Symbol
        </button>
      </div>

      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading instruments...</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Stock Name</th>
                <th style={thStyle}>Symbol</th>
                <th style={thStyle}>LTP Price (₹)</th>
                <th style={thStyle}>Percent Change</th>
                <th style={thStyle}>Asset Type</th>
                <th style={thStyle}>Trading Status</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {instruments.map((inst) => (
                <tr key={inst._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                  <td style={{ ...tdStyle, fontWeight: "bold", color: "#fff" }}>{inst.name}</td>
                  <td style={{ ...tdStyle, color: "#4184f3" }}>{inst.symbol}</td>
                  <td style={tdStyle}>₹{inst.price?.toFixed(2)}</td>
                  <td style={{ ...tdStyle, color: inst.isDown ? "#ef5350" : "#4caf50" }}>
                    {inst.percentChange || "0.00%"}
                  </td>
                  <td style={tdStyle}>{inst.assetType || "Equity"}</td>
                  <td style={tdStyle}>
                    <span
                      style={{
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        backgroundColor: inst.isTradable !== false ? "rgba(76, 175, 80, 0.15)" : "rgba(239, 83, 80, 0.15)",
                        color: inst.isTradable !== false ? "#4caf50" : "#ef5350",
                      }}
                    >
                      {inst.isTradable !== false ? "ENABLED" : "DISABLED"}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <button onClick={() => handleToggleTradable(inst._id, inst.isTradable)} style={smallBtnStyle}>
                      {inst.isTradable !== false ? "Disable" : "Enable"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Add Instrument Modal */}
      {isModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>Add New Tradable Instrument</h3>
            <form onSubmit={handleAddSubmit}>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Company Name / Instrument Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="e.g. RELIANCE INDUSTRIES"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Stock Ticker Symbol</label>
                <input
                  type="text"
                  value={symbol}
                  onChange={(e) => setSymbol(e.target.value.toUpperCase())}
                  placeholder="e.g. RELIANCE"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Simulated LTP Price (₹)</label>
                <input
                  type="number"
                  step="0.05"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder="e.g. 2450.00"
                  required
                  style={inputStyle}
                />
              </div>

              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Asset Segment</label>
                <select value={assetType} onChange={(e) => setAssetType(e.target.value)} style={inputStyle}>
                  <option value="Equity">Equity</option>
                  <option value="Futures">Futures</option>
                  <option value="Options">Options</option>
                </select>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
                <button type="button" onClick={() => setIsModalOpen(false)} style={cancelBtnStyle}>Cancel</button>
                <button type="submit" style={btnStyle}>Save Stock Instrument</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const smallBtnStyle = {
  padding: "4px 8px",
  backgroundColor: "#2a2e39",
  color: "#b2b5be",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "11px",
};

const cancelBtnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2a2e39",
  color: "#fff",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalContentStyle = {
  backgroundColor: "#2a2e39",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "460px",
  color: "#fff",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "6px",
  color: "#d1d4dc",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #434651",
  backgroundColor: "#1e222d",
  color: "#fff",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default InstrumentMaster;
